export default {
  getCommentTarget: function() {
    if(Kadenze.Util.getParameterByName('comment')) {
      return '#comment_' + Kadenze.Util.getParameterByName('comment');
    } else if (Kadenze.Util.getParameterByName('comment_id')) {
      return '#comment_' + Kadenze.Util.getParameterByName('comment_id');
    }
  },
  scrollToElement: function(element) {
    var container = $('body'), scrollTo = $(element);
    if (scrollTo.length > 0) {
      container.animate({
        scrollTop: scrollTo.offset().top
      }, 400, 'swing'); // TO-DO: add better easing
    }
  }
};